import { initialize } from "./helpers/init";
import loadBundles from "./helpers/loadBundles";
import Menu from "./components/menu";
import initAlpine from "./components/alpine";

import "./helpers/validations";
//import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

initAlpine();

document.onreadystatechange = () => {
  initialize("menu", Menu);
};

/* Conditionally load bundles */

loadBundles();